<script>
export default {
  name: "IrregularVerbsTable",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    headers() {
      return Object.keys(this.items[0]);
    }
  }
};
</script>

<template>
  <div class="irregular-verbs-table">
    <table>
      <thead>
        <tr>
          <th v-for="(header, headerIndex) in headers" :key="headerIndex">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, itemIndex) in items" :key="itemIndex">
          <td v-for="(header, headerIndex) in headers" :key="headerIndex">{{ item[header] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
